export const SET_ONLINE = 'SET_ONLINE';
export const SET_SERVER_UP = 'SET_SERVER_UP';
export const SET_OFFLINE_MODE = 'SET_OFFLINE_MODE';
export const SET_OFFLINE_SYNCE_IN_PROGRESS = 'SET_OFFLINE_SYNCE_IN_PROGRESS';



// WEBPACK FOOTER //
// ./src/state/connection/types.js